module.exports = __webpack_public_path__ + "static/media/XBOX5.248ffba4.png";